module.exports = __webpack_public_path__ + "static/media/service_laundry.3c2166de.png";